import { render, staticRenderFns } from "./DocumentAbbrevs.vue?vue&type=template&id=f4faee56"
import script from "./DocumentAbbrevs.vue?vue&type=script&lang=js"
export * from "./DocumentAbbrevs.vue?vue&type=script&lang=js"
import style0 from "./DocumentAbbrevs.vue?vue&type=style&index=0&id=f4faee56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports